import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Bell } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { useNavigate } from "react-router-dom";

export default function NotificationsBell({ testId = "notifications-bell" }) {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const navigate = useNavigate();

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data.notifications || []);
      setUnread(data.unread || 0);
    } catch (err) { console.debug("notifications poll failed", err); }
  };
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  const markAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  const openItem = async (n) => {
    await api.post(`/notifications/${n.notification_id}/read`);
    if (n.link) navigate(n.link);
    load();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid={testId} className="relative p-2 rounded-full hover:bg-[#F7F4EC] transition-colors">
          <Bell size={20} className="text-[#2C2A29]" />
          {unread > 0 && (
            <span className="absolute top-1 right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#E07A5F] text-white text-[10px] font-bold flex items-center justify-center">
              {unread}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 rounded-2xl p-2 border-[#EBE5D9] bg-white shadow-[0_20px_40px_rgb(0,0,0,0.08)]">
        <div className="flex items-center justify-between px-3 py-2">
          <span className="font-display text-lg font-semibold text-[#2C2A29]">Notifications</span>
          <button onClick={markAll} data-testid="mark-all-read" className="text-xs text-[#E07A5F] font-semibold">Mark all read</button>
        </div>
        <div className="max-h-96 overflow-auto hide-scrollbar">
          {items.length === 0 && (
            <div className="text-sm text-[#7A7571] px-3 py-6 text-center">No notifications yet</div>
          )}
          {items.map((n) => (
            <button
              key={n.notification_id}
              onClick={() => openItem(n)}
              data-testid={`notification-${n.notification_id}`}
              className={`w-full text-left px-3 py-3 rounded-xl hover:bg-[#F7F4EC] transition-colors ${n.read ? "opacity-70" : ""}`}
            >
              <div className="text-sm font-semibold text-[#2C2A29]">{n.title}</div>
              <div className="text-xs text-[#7A7571] mt-1 line-clamp-2">{n.body}</div>
            </button>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
